import { sourceLookupErrorMessage } from '@Purchasing/Utils/sourceLookupError'
import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { SourceContext } from '@Purchasing/Domain/Model/PurchaseProcess'
import { useCallback, useState } from 'react'

export const useSourceContext = () => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseGetSourceContext
    )
    const [sourceContext, setSourceContext] = useState<SourceContext | null>(
        null
    )
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const load = useCallback(
        async (code?: string, externalId?: string) => {
            setLoading(true)
            setError(null)
            try {
                const result = await useCase.execute(code, externalId)
                setSourceContext(result)
                return result
            } catch (e: any) {
                console.error(e)
                setError(sourceLookupErrorMessage(e))
                setSourceContext(null)
                return null
            } finally {
                setLoading(false)
            }
        },
        [useCase]
    )

    return { sourceContext, loading, error, loadSourceContext: load }
}
